import { Flex, Text } from '@chakra-ui/react';
import { OutlineCard } from '@morressier/alembic';
import { GenericSubmissionField } from 'src/components/Submission/MySubmission/FormFieldGeneric/GenericSubmissionField';
import { useAssessmentData } from 'src/contexts/AssessmentDataProvider';

const AboutTab = () => {
  const { fieldsResponse } = useAssessmentData();
  const subjectArea = fieldsResponse?.fields['SubjectArea'];

  return (
    <Flex flexDirection="column" gap={6} paddingX={14}>
      <Text textStyle="headingTitle">About</Text>
      <Text textStyle="textBody">
        Verify this submission’s preferences, statements and author consents.
      </Text>
      {fieldsResponse.fields.NoveltyStatement && (
        <Flex direction={'column'} wrap={'wrap'} gap={3}>
          <Text textStyle="headingItem">Motivation to Publish</Text>
          <OutlineCard borderRadius={0} borderColor={'transparent'} padding={3}>
            <GenericSubmissionField
              entryPoint="early-assessment"
              fieldName="NoveltyStatement"
            />
          </OutlineCard>
        </Flex>
      )}
      {fieldsResponse.fields.DataAvailability && (
        <Flex direction={'column'} wrap={'wrap'} gap={3}>
          <OutlineCard borderRadius={0} borderColor={'transparent'} padding={3}>
            <GenericSubmissionField
              entryPoint="early-assessment"
              fieldName="DataAvailability"
            />
          </OutlineCard>
          {fieldsResponse.fields.DataAvailabilityOpenlyAvailableUrl &&
            (fieldsResponse.fields.DataAvailability.value as any)?.status ===
              'openly-available' && (
              <OutlineCard
                borderRadius={0}
                borderColor={'transparent'}
                padding={3}
              >
                <GenericSubmissionField
                  entryPoint="early-assessment"
                  fieldName="DataAvailabilityOpenlyAvailableUrl"
                />
              </OutlineCard>
            )}
          {fieldsResponse.fields.DataAvailabilityEmbargoUrl &&
            (fieldsResponse.fields.DataAvailability.value as any)?.status ===
              'embargo-period' && (
              <OutlineCard
                borderRadius={0}
                borderColor={'transparent'}
                padding={3}
              >
                <GenericSubmissionField
                  entryPoint="early-assessment"
                  fieldName="DataAvailabilityEmbargoUrl"
                />
              </OutlineCard>
            )}
          {fieldsResponse.fields.DataAvailabilityEmbargoDate &&
            (fieldsResponse.fields.DataAvailability.value as any)?.status ===
              'embargo-period' && (
              <OutlineCard
                borderRadius={0}
                borderColor={'transparent'}
                padding={3}
              >
                <GenericSubmissionField
                  entryPoint="early-assessment"
                  fieldName="DataAvailabilityEmbargoDate"
                />
              </OutlineCard>
            )}
          {fieldsResponse.fields.DataUnavailabilityReason &&
            (fieldsResponse.fields.DataAvailability.value as any)?.status ===
              'not-available' && (
              <OutlineCard
                borderRadius={0}
                borderColor={'transparent'}
                padding={3}
              >
                <GenericSubmissionField
                  entryPoint="early-assessment"
                  fieldName="DataUnavailabilityReason"
                />
              </OutlineCard>
            )}
        </Flex>
      )}
      {subjectArea && typeof subjectArea?.value === 'string' && (
        <Flex direction={'column'} wrap={'wrap'} gap={3}>
          <Text textStyle="headingItem">Additional Preferences</Text>
          <OutlineCard borderRadius={0} borderColor={'transparent'} padding={3}>
            <Text textStyle="headingItem" data-cy="subject-area-title-text">
              {subjectArea?.formFieldDefinition.params.labels.main}
            </Text>
            <Text textStyle="textBody" data-cy="subject-area">
              {subjectArea?.value}
            </Text>
          </OutlineCard>
        </Flex>
      )}
    </Flex>
  );
};

export default AboutTab;
